// Code generated by go test ./internal/contract (refactor plan X4a). DO NOT EDIT.
//
// The Go vocabularies the frontend reads, each written from its Go catalogue,
// with the same values as internal/contract/testdata/contract.json. A stale
// copy fails `go test ./internal/contract/...`; after a deliberate change to a
// vocabulary in Go, regenerate both files with:
//
//   UPDATE_CONTRACTS=1 go test ./internal/contract/...
//
// Each union type is derived from the constant above it, so it names exactly
// the values Go has.

/**
 * The feature keys of release.Registry, in registry order
 * (internal/domain/release).
 */
export const FEATURE_KEYS = [
  'flow-down',
  'artifact-owners',
  'share-links',
  'assistant-project-edits',
  'default-workspace',
  'figure-titles',
  'password-reset',
  'antigravity-cli',
  'todo-list',
  'figure-revert',
  'attachment-formats',
  'figure-citations',
  'search-by-ref',
  'note-tagging',
  'project-review-round',
  'review-queue-decisions',
  'artifact-stepping',
  'workspace-billing',
  'workspace-automations',
  'workspace-runs',
  'workspace-api-keys',
  'remote-mcp',
  'auto-cloud-runner',
  'claude-subscription-token',
  'cloud-runner-token',
  'connected-app-workspaces',
  'linked-sign-in',
  'manual-help',
  'help-activity',
  'target-releases',
  'compact-layout',
  'redesign-pages',
] as const;
export type FeatureKey = (typeof FEATURE_KEYS)[number];

/**
 * The domain event types: the constant block of events.ArtifactCreated
 * (internal/domain/events), in declaration order.
 */
export const DOMAIN_EVENT_TYPES = [
  'artifact.created',
  'artifact.updated',
  'artifact.deleted',
  'artifact.status_changed',
  'artifact.restored',
  'link.created',
  'link.updated',
  'link.deleted',
  'baseline.captured',
  'baseline.deleted',
  'project.review_round_started',
  'chatter.created',
  'testrun.recorded',
  'workitem.created',
  'workitem.moved',
  'workitem.updated',
  'agentrun.finished',
  'agentrun.successors_skipped',
  'proposal.created',
  'org.member_added',
  'org.member_role_changed',
  'org.member_removed',
  'org.invitation_sent',
  'org.invitation_accepted',
  'project.member_added',
  'project.member_role_changed',
  'project.member_removed',
] as const;
export type DomainEventType = (typeof DOMAIN_EVENT_TYPES)[number];

/**
 * The event names the server sends on an SSE stream, sorted: S6's
 * contracts/sse-events.json, which internal/api's TestSSEContract writes from
 * the Go sources.
 */
export const SSE_EVENT_NAMES = [
  'assistant_partial',
  'error',
  'log',
  'message',
  'notification',
  'partial',
  'status',
] as const;
export type SseEventName = (typeof SSE_EVENT_NAMES)[number];

/**
 * The API's machine-readable error codes: the constant block of
 * api.ErrCodeEmailUnverified (internal/api), in declaration order.
 */
export const API_ERROR_CODES = [
  'email_unverified',
  'registration_closed',
  'invitation_email_mismatch',
  'weak_password',
  'password_incorrect',
  'limit_reached',
  'plan_read_only',
  'no_password',
  'reset_invalid',
  'reset_email_unavailable',
  'sso_only',
  'billing_unavailable',
  'billing_upstream',
  'unknown_plan',
  'already_subscribed',
  'no_subscription',
  'granted_plan',
  'no_customer',
  'checkout_mismatch',
] as const;
export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

/**
 * The link type rules of links.GetLinkTypeRules, with their Go text
 * (internal/domain/links).
 */
export const LINK_TYPE_RULES = [
  {
    type: 'verifies',
    label: 'verifies',
    inverseLabel: 'verified by',
    allowedFromTypes: ['test-case'],
    allowedToTypes: ['requirement'],
    description: 'A test case demonstrates that a requirement is met',
  },
  {
    type: 'satisfies',
    label: 'satisfies',
    inverseLabel: 'satisfied by',
    allowedFromTypes: ['design-item'],
    allowedToTypes: ['requirement'],
    description: 'A design element implements or fulfills a requirement',
  },
  {
    type: 'mitigates',
    label: 'mitigates',
    inverseLabel: 'mitigated by',
    allowedFromTypes: ['design-item'],
    allowedToTypes: ['hazard'],
    description: 'A design element reduces or eliminates a hazard',
  },
  {
    type: 'decomposes-to',
    label: 'decomposes to',
    inverseLabel: 'decomposed from',
    allowedFromTypes: ['requirement'],
    allowedToTypes: ['requirement'],
    description: 'A high-level requirement is broken down into more specific sub-requirements',
  },
  {
    type: 'refines',
    label: 'refines',
    inverseLabel: 'refined by',
    allowedFromTypes: ['requirement'],
    allowedToTypes: ['requirement'],
    description: 'A requirement in a subsystem or supplier project refines a requirement of its parent project; the parent\'s verification rolls the refinements up',
  },
  {
    type: 'derives-from',
    label: 'derives from',
    inverseLabel: 'gives rise to',
    allowedFromTypes: ['requirement'],
    allowedToTypes: ['user-need'],
    description: 'A requirement is derived from a user need',
  },
  {
    type: 'validates',
    label: 'validates',
    inverseLabel: 'validated by',
    allowedFromTypes: ['test-case'],
    allowedToTypes: ['user-need'],
    description: 'A test case confirms that a user need is met',
  },
  {
    type: 'impacts',
    label: 'impacts',
    inverseLabel: 'impacted by',
    allowedFromTypes: ['*'],
    allowedToTypes: ['*'],
    description: 'A change to one artifact affects another',
  },
  {
    type: 'relates-to',
    label: 'relates-to',
    inverseLabel: 'relates-to',
    allowedFromTypes: ['*'],
    allowedToTypes: ['*'],
    description: 'A loose, non-semantic association between artifacts',
  },
] as const;
export type LinkType = (typeof LINK_TYPE_RULES)[number]['type'];

/**
 * The artifact types of artifacts.TypeCatalog, with their labels
 * (internal/domain/artifacts).
 */
export const ARTIFACT_TYPE_CATALOG = [
  {
    value: 'heading',
    label: 'Heading',
  },
  {
    value: 'description',
    label: 'Description',
  },
  {
    value: 'persona',
    label: 'Persona',
  },
  {
    value: 'user-need',
    label: 'User Need',
  },
  {
    value: 'requirement',
    label: 'Requirement',
  },
  {
    value: 'design-item',
    label: 'Design Item',
  },
  {
    value: 'test-case',
    label: 'Test Case',
  },
  {
    value: 'hazard',
    label: 'Hazard',
  },
  {
    value: 'other',
    label: 'Other',
  },
] as const;
export type ArtifactTypeValue = (typeof ARTIFACT_TYPE_CATALOG)[number]['value'];

/**
 * The artifact statuses, the constant block of artifacts.StatusDraft in
 * declaration order, each with the statuses artifacts.CanTransition allows
 * next (internal/domain/artifacts).
 */
export const ARTIFACT_STATUSES = [
  {
    value: 'draft',
    next: ['in_review'],
  },
  {
    value: 'in_review',
    next: ['draft', 'approved'],
  },
  {
    value: 'approved',
    next: ['superseded'],
  },
  {
    value: 'superseded',
    next: [],
  },
] as const;
export type ArtifactStatusValue = (typeof ARTIFACT_STATUSES)[number]['value'];

/**
 * The workspace plans: the constant block of orgs.PlanSingle in declaration
 * order, the legacy aliases included (internal/domain/orgs).
 */
export const WORKSPACE_PLANS = [
  'single',
  'business_lite',
  'business',
  'enterprise',
  'self_host',
  'open_source',
  'free',
  'team',
] as const;
export type WorkspacePlan = (typeof WORKSPACE_PLANS)[number];

/**
 * The V&V gap lists, by the JSON key GET /api/v1/projects/{id}/vv/gaps sends
 * them under, with the title the reports print, in report order
 * (internal/domain/reports).
 */
export const VV_GAP_LABELS = [
  {
    key: 'requirements_without_method',
    label: 'Requirements without a verification method',
  },
  {
    key: 'requirements_without_test_case',
    label: 'Requirements without a test case',
  },
  {
    key: 'requirements_unverified',
    label: 'Unverified (demonstration, analysis, inspection)',
  },
  {
    key: 'requirements_failing',
    label: 'Requirements with failing tests',
  },
  {
    key: 'orphan_test_cases',
    label: 'Orphan test cases (verify nothing)',
  },
  {
    key: 'needs_without_requirement',
    label: 'User needs without a derived requirement',
  },
  {
    key: 'hazards_unmitigated',
    label: 'Unmitigated hazards',
  },
] as const;
export type VvGapKey = (typeof VV_GAP_LABELS)[number]['key'];

/**
 * The agent providers of providers.KnownProviders, in display order
 * (internal/domain/providers).
 */
export const AGENT_PROVIDERS = [
  'claude-code',
  'codex-cli',
  'gemini-cli',
  'antigravity-cli',
  'anthropic-api',
  'openai-api',
  'google-api',
] as const;
export type AgentProvider = (typeof AGENT_PROVIDERS)[number];
